import React, { ChangeEvent, Suspense, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { useParams } from 'react-router-dom'
import { useAssetCRUD } from 'src/hooks/api'
// import selectData from 'src/data'
import { AssetDetails, EditableInfo, LoginResponse } from 'src/types'
import Loading from 'src/components/Loading/Loading'
import { useSelector } from 'react-redux'
import TextArea from './Form/TextArea'
import ToggleSection from './Form/ToggleSection'

interface AssetFormProps {
  asset: AssetDetails
  setAsset: (value: AssetDetails) => void
  hasChanges?: boolean
  onSave?: () => void
}

const AssetForm = ({ asset, setAsset, hasChanges, onSave }: AssetFormProps) => {
  const { assetId } = useParams()
  const assetCRUD = useAssetCRUD()
  const { role } = useSelector((s: {user: LoginResponse}) => s.user)

  const [state, setState] = useState('success')

  const handleSubmit = async e => {
    e.preventDefault()
    setState('loading')
    try {
      await assetCRUD.update(assetId, asset)
      setState('success')
      onSave && onSave()
    } catch (e) {
      setState('error')
      console.warn(e)
    }
  }
  const geolock = asset?.editableInfo?.geolock

  const isClient = role === 'CLIENT'

  const handleGeolock = (value: boolean) => {
    if (!isClient) { return }
    setAsset({
      ...asset,
      editableInfo: { ...asset.editableInfo, geolock: value }
    })
  }

  const handleText = (e: ChangeEvent<HTMLTextAreaElement>, key: keyof EditableInfo) => {
    const { target: { value } } = e
    setAsset({
      ...asset,
      editableInfo: {
        ...asset.editableInfo,
        [key]: value
      }
    })
  }

  return (
    <form id="asset-form" onSubmit={handleSubmit}>
      <button className="filled" disabled={!hasChanges || state === 'loading'}>
        <FormattedMessage id={state === 'loading' ? 'saving' : hasChanges ? 'save' : 'saved'} />
      </button>
      {state === 'error' &&
        <span className="error-message">
          <FormattedMessage id="save-error" />
        </span>
      }
      <section id="general-info">
        <div className="row">
          <label>
            <h2><FormattedMessage id="asset-form.prinexId" /></h2>
            <input
              value={asset.active.prinexId || ''}
              name="prinexId"
              readOnly
            />
          </label>
          <label>
            <h2><FormattedMessage id="asset-form.subscriberCode" /></h2>
            <select>
              {asset.active.subscribers?.map(sub =>
                <option>{sub.code}</option>
              )}
            </select>
          </label>
        </div>
        <div className="row">
          <label>
            <h2><FormattedMessage id="asset-form.address" /></h2>
            <input
              value={asset.active.address || ''}
              name="address"
              readOnly
            />
          </label>
        </div>
        <div className="row">
          {/* <label>
            <h2><FormattedMessage id="asset-form.province" /></h2>
            <select
              value={asset.active.province.toUpperCase() || ''}
              name="province"
              readOnly
            >
              <option hidden value="">Selecciona una provincia</option>
              {selectData.provinces.map(p => (
                <option key={p} value={p.toUpperCase()}>{p}</option>
              ))}
            </select>
          </label> */}
          <label>
            <h2><FormattedMessage id="asset-form.province" /></h2>
            <input
              value={asset.active.province || ''}
              name="province"
              readOnly
            />
          </label>
        </div>
        <div className="row">
          <label>
            <h2><FormattedMessage id="asset-form.city" /></h2>
            <input
              value={asset.active.city || ''}
              name="city"
              readOnly
            />
          </label>
          <label>
            <h2><FormattedMessage id="asset-form.zipCode" /></h2>
            <input
              value={asset.active.zipCode || ''}
              type="number"
              name="zipCode"
              readOnly
            />
          </label>
        </div>
      </section>
      <section id="armed-info">
        <h2><FormattedMessage id="asset-form.armed-info.title" /></h2>
        {/* <p><FormattedMessage id="asset-form.armed-info.text" /></p> */}
        <ToggleSection
          toggle={{
            disabled: !isClient,
            handleChange: handleGeolock,
            value: geolock || false
          }}
          options={{
            disabled: {
              handleClick: geolock ? () => handleGeolock(false) : undefined,
              title: 'switcher.not-allow'
            },
            enabled: {
              handleClick: !geolock ? () => handleGeolock(true) : undefined,
              title: 'switcher.allow'
            }
          }}
        />
        <TextArea
          handleChange={handleText}
          name="comment"
          title="asset-form.comment"
          value={asset.editableInfo.comment || ''}
        />
        <TextArea
          handleChange={handleText}
          name="description"
          title="asset-form.description"
          value={asset.editableInfo.description || ''}
        />
      </section>
    </form>
  )
}

const AssetFormWrapper = (props) =>
  <Suspense fallback={<Loading />}>
    <AssetForm {...props} />
  </Suspense>

export default AssetFormWrapper
